import { Outlet } from "react-router-dom";

import { FilterTerminationTypeProvider } from "./filter-termination-type/filter-termination-type.context";
import './termination-type.scss';

export function TerminationType() {
  return (
    <div id="TerminationType" className="termination-type">
       <FilterTerminationTypeProvider>
        <Outlet />
      </FilterTerminationTypeProvider>
    </div>
  );
}

export default TerminationType;
